import 'bootstrap/js/src/button'

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.check').forEach(c => {
    c.addEventListener('click', e => {
      const state = c.querySelector('input[type=checkbox]').checked
      document.querySelectorAll(`.score-list .progress-bar.bg-${c.dataset.status}`).forEach(b => {
        b.style.width = `${state ? b.dataset.value : 0}%`
      })
    })
  })
})